import { msg } from '@gonfalon/messages/msg';

export const getApprovalApplyFailedNotificationMessage = () => msg('approvals.notification.applyFailed');
